import { AsyncPipe, CommonModule, CurrencyPipe, DatePipe, JsonPipe } from '@angular/common';
import { AfterViewInit, Component, DestroyRef, inject, OnInit, ViewChild } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatOptionModule } from '@angular/material/core';
import { MatDatepickerModule, MatDateRangeInput } from '@angular/material/datepicker';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSnackBar, MatSnackBarModule, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import {
  IGX_GRID_DIRECTIVES,
  IgxActionStripModule,
  IgxExcelExporterOptions,
  IgxExcelExporterService,
  IgxGridComponent,
  IgxGridModule,
  IgxSwitchModule,
  IgxTabsModule,
  IPinningConfig,
  RowPinningPosition,
} from '@infragistics/igniteui-angular';
import { AppGeneralStateService } from 'src/app/app-general-state.service';
import { DataService } from 'src/app/core/services/data/data.service';
import { MessageDialogService } from 'src/app/core/services/helper/message-dialog.service';
import {
  IAgingCommentsDialogUpdate,
  IInvoiceAsOfAgingResult,
  IUserListByLotNumberResponse,
} from 'src/app/shared/interfaces';
import { HeaderTitleLotDataComponent } from 'src/app/shared/ui/header-title-lot-data/header-title-lot-data.component';
import { environment } from 'src/environments/environment';
import { IgxPreventDocumentScrollModule } from 'src/app/shared/directives/prevent-scroll.directive';
import { MatCheckboxModule } from '@angular/material/checkbox';

@Component({
  selector: 'app-users-by-lot',
  standalone: true,
  imports: [
    MatSlideToggleModule,
    MatExpansionModule,
    MatIconModule,
    CommonModule,
    MatTabsModule,
    MatSnackBarModule,
    MatTableModule,
    MatCardModule,
    MatOptionModule,
    MatInputModule,
    MatFormFieldModule,
    MatDatepickerModule,
    ReactiveFormsModule,
    MatProgressSpinnerModule,
    MatSelectModule,
    IgxGridModule,
    IgxTabsModule,
    IgxGridComponent,
    HeaderTitleLotDataComponent,
    MatTooltipModule,
    MatButtonModule,
    MatDialogModule,
    IgxActionStripModule,
    IgxSwitchModule,
    IgxPreventDocumentScrollModule,
    MatCheckboxModule,
    FormsModule,
  ],
  templateUrl: './users-by-lot.component.html',
  styleUrl: './users-by-lot.component.scss',
})
export class UsersByLotComponent implements OnInit {
  userList: IUserListByLotNumberResponse[] = [];

  #_dataService = inject(DataService);
  #_destroyRefService = inject(DestroyRef);
  #_snackBar = inject(MatSnackBar);
  #_messageService = inject(MessageDialogService);
  _appGeneralState = inject(AppGeneralStateService);

  constructor() {}

  ngOnInit(): void {
    this.getUserListForLotNumber(this._appGeneralState.currentLotNumber);

    this._appGeneralState.lotNumberSubject.subscribe({
      next: (v) => this.getUserListForLotNumber(this._appGeneralState.currentLotNumber),
    });
  }

  displaySearchMessage(): void {
    const verticalPosition: MatSnackBarVerticalPosition = 'top';
    this.#_snackBar.open('Loading User by Lot Number List...', '', { verticalPosition: verticalPosition });
  }

  getUserListForLotNumber(lotNumber: string) {
    this.userList = [];

    this.#_dataService
      .getUserLitByLotNumber(lotNumber)
      .pipe(takeUntilDestroyed(this.#_destroyRefService))
      .subscribe({
        next: (res) => {
          this.userList = res;
        },
        error: (err: any) => {
          this.#_snackBar.dismiss();
          this.#_messageService.snackBarTopCenterTimed(
            'An unexpected error occurred while loading the User Name list.  Please try again.',
            5000,
          );
        },
        complete: () => {
          this.#_snackBar.dismiss();
          if (this.userList.length == 0) {
            this.#_messageService.snackBarTopCenterTimed('No users were located for this lot.', 5000);
          }
        },
      });
  }
}
